export default "__VITE_ASSET__9BuYXXYp__"